import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineCoreFileCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#999"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="m5.375 9.575 1.575 1.05 3.15-4.2"
    />
    <path
      stroke="#999"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M13.775 13.775a1.05 1.05 0 0 1-1.05 1.05h-9.45a1.05 1.05 0 0 1-1.05-1.05V2.225a1.05 1.05 0 0 1 1.05-1.05H10.1l3.675 3.675z"
    />
  </svg>
);
export default SvgStreamlineCoreFileCheck;
